// extracted by css-extract-rspack-plugin
export default {"cls1":"buttonStyles-cls1_Fih","cls2":"buttonStyles-cls2_RYD buttonStyles-cls1_Fih"};